// 手机号
export function checkPhone(rule, value, callback) {
  if (!value) {
    callback()
  } else {
    const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/ //手机号正则表达式
    const regB = /^([0-9]{3,4}-)?[0-9]{7,8}$/ //座机号正则表达式
    if (reg.test(value)) {
      callback()
    } else if (regB.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的联系方式'))
    }
  }
}

export function checkNumber(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入专家人数'))
  } else {
    const reg = /^[0-9]+[0-9]*]*$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('输入内容不能为小数'))
    }
  }
}

// 万元
export function checkXSNumber(rule, value, callback) {
  if (!value) {
    callback()
  } else {
    const reg = /^[0-9]+(.[0-9]{1,6})?$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('输入内容大于等于0、小数保留6位'))
    }
  }
}
// 平方米
export function checkmmNumber(rule, value, callback) {
  if (!value) {
    callback()
  } else {
    const reg = /^[0-9]+(.[0-9]{1,4})?$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('输入内容大于等于0、小数保留4位'))
    }
  }
}

// 只能输入正整数
export function integerNumbers(rule, value, callback) {
  if (!value) {
    callback()
  } else {
    const reg = /^[1-9]\d*$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('输入内容要为大于0的正整数'))
    }
  }
}

// 邮箱
export function Email(rule, value, callback) {
  if (!value) {
    callback()
  } else {
    const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的邮箱地址'))
    }
  }
}

// 身份证
export function IDNumber(rule, value, callback) {
  if (!value) {
    callback()
  } else {
    let _IDRe18 =
      /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    let _IDre15 =
      /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/

    if (_IDRe18.test(value) || _IDre15.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的身份证'))
    }
  }
}

// 姓名
export function Name(rule, value, callback) {
  if (!value) {
    callback()
  } else {
    const reg = /^[\u4e00-\u9fa5]{2,6}$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入2~6位中文姓名'))
    }
  }
}

// 社会信用代码
export function creditCode(rule, value, callback) {
  if (!value) {
    callback()
  } else {
    const reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的社会信用代码'))
    }
  }
}
